import React, { useState } from 'react'
import {
  Icon,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
} from '@material-ui/core'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined'
import { useIntl } from 'react-intl'

export default ({ onEdit, onDelete, noteId }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { formatMessage } = useIntl()

  const openMenu = (event) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  function closeMenu(event) {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const handleMenuItemClick = (event) => {
    closeMenu(event)
  }
  return (
    <div>
      <IconButton
        color="secondary"
        className="p-0"
        aria-owns={anchorEl ? 'selectMenu' : null}
        aria-haspopup="true"
        onClick={openMenu}
      >
        <Icon>more_horiz</Icon>
      </IconButton>
      <Menu
        id="selectMenu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        className="p-0"
      >
        <MenuList className="p-0">
          <MenuItem
            key="NoteEdit"
            disableRipple
            onClick={(e) => {
              handleMenuItemClick(e)
              onEdit(noteId)
            }}
            className="space-x-4 text-blue-950 flex items-center p-0 px-5"
          >
            <ListItemIcon className="min-w-0">
              <EditOutlinedIcon fontSize="small" className="text-blue-950" />
            </ListItemIcon>
            <ListItemText
              className="text-blue-950"
              primary={formatMessage({ id: 'action.update' })}
            />
          </MenuItem>
          <MenuItem
            key="NoteDelete"
            disableRipple
            onClick={(e) => {
              handleMenuItemClick(e)
              onDelete(noteId)
            }}
            className="space-x-4 text-red-500 flex items-center"
          >
            <ListItemIcon className="min-w-0">
              <DeleteOutlineOutlinedIcon
                fontSize="small"
                className="text-red-500"
              />
            </ListItemIcon>
            <ListItemText primary={formatMessage({ id: 'action.delete' })} />
          </MenuItem>
        </MenuList>
      </Menu>
    </div>
  )
}
